
export default function FounderMessage() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Message from the Founder &amp; CEO
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="bg-white rounded-lg p-8 shadow-lg">
              <blockquote className="text-lg text-gray-700 mb-6 italic">
                "At Marketing Ads, our vision is clear — to empower brands to achieve measurable growth through strategic digital marketing and performance-driven solutions."
              </blockquote>
              
              <p className="text-gray-600 mb-4">
                When I founded this agency, my mission was to create a space where creativity, data, and results come together. We don't just run campaigns; we build digital ecosystems that turn brands into market leaders.
              </p>
              
              <p className="text-gray-600 mb-6">
                Our team believes in transparency, innovation, and commitment. Every project we take on is treated with the same dedication as our own brand.
              </p>

              <div className="border-t border-gray-200 pt-6">
                <h4 className="font-semibold text-gray-900 mb-2">Our Vision:</h4>
                <p className="text-gray-600 mb-4">
                  To establish Marketing Ads as one of India's Top 10 E-commerce Marketing Agencies within the next two years, known for delivering unmatched ROI and result-oriented performance marketing.
                </p>

                <h4 className="font-semibold text-gray-900 mb-2">Our Mission:</h4>
                <p className="text-gray-600 mb-6">
                  To help e-commerce brands scale efficiently through creativity, analytics, and strategy — turning digital potential into measurable success stories.
                </p>

                <div className="flex items-center">
                  <div>
                    <p className="font-semibold text-gray-900">Narendra Kumar</p>
                    <p className="text-gray-600">Founder &amp; CEO, Marketing Ads</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/8eefe0b826460d6d105fc050dc18b4b0/51090e36dbab5fba64f662ab6592b89d.jpeg"
                alt="Narendra Kumar - Founder & CEO"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
